import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import { ExpansionPanel, ExpansionPanelDetails,TableCell,Table,TableHead, ExpansionPanelSummary, Typography, TableRow, TableBody} from '@material-ui/core';
import MissingFileSessionRow from './MissingFileSessionRow.component';
import {findMissingFilesInSession} from '../../../../helpers/findMissingFileInSession.helper.js';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "0"
  },
  title: {
    margin: "5px 0px"
  },
  table: {
    minWidth: "100%"
  },
  lastTable: {
    minWidth: "100%",
    marginBottom: "50px"
  },
  insidepanel: {
    padding: "0px"
  },
  spacing: {
    margin: "9px 0"
  }

});
const MissingFiles = ({session,classes}) => {
  const missingFiles = findMissingFilesInSession(session);

  const renderMissingTableRows = () =>{
    return missingFiles.map(filename => (
      <MissingFileSessionRow
        key={filename}
        sessionId={session.id}
        filename={filename}
      />
    ));
  }

  return missingFiles.length > 0 ? (
    <ExpansionPanel className={classes.root}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.title} variant="subtitle1">
          Missing Files ({missingFiles.length})
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.insidepanel}>
        <Table className={classes.table} aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell>Filename</TableCell>

              <TableCell colSpan={4}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderMissingTableRows()}</TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  ) : (
    ""
  );
}

export default withStyles(styles)(MissingFiles);
